
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as PasswordIconComponent } from "./password-icon.svg";

export const PasswordIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <PasswordIconComponent {...props} />;
};
